import React, {useEffect, useRef, useState} from "react";
import "./Favorites.css";
import Row from "react-bootstrap/Row";
import Node from "../../BondTree/Node";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {faRotateRight} from "@fortawesome/free-solid-svg-icons/faRotateRight";

const autoReloadTime = 1000;


function ResizableFavorite({path, bond, reloadTimestamp, reloadFavorites, settings}) {
    const [colSize, setColSize] = useState(settings["colSize"] || 6);

    function saveSettings() {
        const favoriteKey = "favorites_" + bond.id;
        let favorites = JSON.parse(localStorage.getItem(favoriteKey));
        favorites[path] = {colSize: colSize};
        localStorage.setItem("favorites_" + bond.id, JSON.stringify(favorites));
    }

    useEffect(() => {
        if (colSize < 2) setColSize(2);
        if (colSize > 12) setColSize(12);
        saveSettings();
    }, [colSize]);

    return <Col className={`col-${colSize} resizableFavorite`} key={path}>
        <Row className={"sticky-top"}>
            <InputGroup>
                <Form.Control
                    value={path}
                    readOnly={true}
                />
                <Button variant={"outline-danger"} onClick={() => {
                    setColSize(colSize - 1)
                }}>
                    <FontAwesomeIcon icon={faArrowLeft}/>
                </Button>
                <Button variant={"outline-danger"} onClick={() => {
                    setColSize(colSize + 1)
                }}><FontAwesomeIcon icon={faArrowRight}/>
                </Button>
            </InputGroup>
        </Row>
        <Node bond={bond} parentU={null} path={path} reloadTimestamp={reloadTimestamp} isOpen={true}
              label={path} reloadFavorites={reloadFavorites}/>
    </Col>;
}


function Favorites({bond, currentTab}) {
    const [favorites, setFavorites] = useState({});
    const [autoReload, setAutoReload] = useState(false);
    const [reloadTimestamp, setReloadTimestamp] = useState(null);
    const reloadIntervalRef = useRef(0);

    useEffect(() => {
        getFavorites();
    }, []);

    useEffect(() => {
        if (currentTab === "favorites") {
            getFavorites();
        }
    }, [currentTab]);

    function reload() {
        setReloadTimestamp(Date.now());
    }

    useEffect(() => {
        if (autoReload) reloadIntervalRef.current = setInterval(() => reload(), autoReloadTime); else clearInterval(reloadIntervalRef.current);
        return () => clearInterval(reloadIntervalRef.current);
    }, [autoReload]);


    function getFavorites() {
        const favoriteKey = "favorites_" + bond.id;
        let favorites = localStorage.getItem(favoriteKey) || "{}";
        setFavorites(JSON.parse(favorites));
    }


    return (<Row className={"favoritesRow"}>
        <Row className="w-25 pb-3">
            <ButtonGroup className={"bondTreeButtonGroup"}>
                <Button variant="outline-primary"
                        className=""
                        onClick={reload}
                        disabled={autoReload ? "disabled" : ""}>Reload
                </Button>
                <Button className={"bondTreeAutoReloadButton"}
                        variant={autoReload ? "success" : "outline-primary"}
                        onClick={() => setAutoReload(!autoReload)}>
                    <FontAwesomeIcon icon={faRotateRight} className={autoReload ? "fa-spin" : ""}/>
                </Button>
            </ButtonGroup>
        </Row>
        <Row>
            {Object.keys(favorites).map((path, index) => (
                <ResizableFavorite path={path} key={index} bond={bond} reloadTimestamp={reloadTimestamp}
                                   reloadFavorites={getFavorites}
                                   settings={favorites[path]}/>))}
        </Row>
    </Row>);
}

export default Favorites;
